// extracted by mini-css-extract-plugin
export default {"BaseLabel":"BaseLabel_BaseLabel__T-LJ-","BaseLabel_disabled":"BaseLabel_BaseLabel_disabled__CDzMn","BaseLabel__label":"BaseLabel_BaseLabel__label__78xoP"};